import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from '@provise/app.vue'
import router from '@/router'
import { initApp } from '@provise/init'

const app = createApp(App)

app.config.globalProperties = {
  defaultTitle: 'ARTAS',
}
app.use(createPinia())
app.use(router)

initApp(app)

app.mount('#app')
